import clsx from "clsx"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { Layout } from "../../../ui/layout"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import Button from "../../../ui/molecules/button"
import { useEffect, useState } from "react"
import { Pagination } from "../../../ui/organisms/pagination"
import { Calendar } from "../../../ui/molecules/calendar"
import { SingleCheckbox } from "../../../ui/molecules/SingleCheckbox"
import { LogoSpinnerComponent } from "../../../lib/spinner/spinnerLogo"
import { GetAllM24Emessi, setGetAllFaseAvvioEndingDate, setGetAllM24EmessiRegion, setGetAllM24EmessiSot, setGetAllM24EmessiStartingDate, setGetAllM24EmessiYear } from "./slice"
import { format } from "date-fns"
import { MonitoringM24EmessiList } from "./list"
import { SelectCustom } from "../../../ui/molecules/select"
import { M024Type, normativa, regioniList, sot, yearOptions } from "../../../utils"

export function MonitoringM24Emessi() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const m24EmessiState = useAppSelector(state => state.m24Emessi)

    if (m24EmessiState.getAllM24EmessiStatus === 'loading') {
        return (
            <LogoSpinnerComponent fullScreen />
        )
    }

    return (
        <Layout menuItem={MenuItems.GESTIONE_CONTROLLO} breadcrumbItems={['Dashboard', 'Gestione Controllo', 'Monitoraggio Fase di Avvio']}
            noPaddingLat
            headerLabel="Monitoraggio M24 Emessi"
        >
            <div style={{ padding: '24px' }}>
                <div className="w-[100%] flex flex-col gap-[16px] filter" style={{ padding: '24px 0px 0px 0px' }}>
                    <div className="flex flex-row gap-[16px]" style={{ flex: 1, alignItems: 'center' }}>
                        <div style={{ justifyContent: 'left', flex: 1 }} className="flex gap-[16px] items-center">
                            <div style={{ flex: '0.33' }}>
                                <SelectCustom
                                    label="Anno"
                                    placeholder={'Anno'}
                                    options={yearOptions}
                                    onChange={(value) => dispatch(setGetAllM24EmessiYear(value))}
                                />
                            </div>
            
                            <div style={{ flex: '0.33' }}>
                                <SelectCustom
                                    label="Sede"
                                    placeholder='Sede'
                                    options={sot}
                                    onChange={(value) => dispatch(setGetAllM24EmessiSot(value))}
                                />
                            </div>


                            <div style={{ flex: '0.33' }}>
                                <SelectCustom
                                    label="Regione"
                                    placeholder='Regione'
                                    options={regioniList}
                                    onChange={(value) => dispatch(setGetAllM24EmessiRegion(value))}
                                />
                            </div>

                            <div style={{ flex: '0.33' }}>
                                <Calendar
                                    label="Dal"
                                    //onClear={(date) => dispatch(setGetAllEPFilterFrom(date))}
                                    selected={m24EmessiState.GetAllM24EmessiFilters.from}
                                    onChange={(date) => dispatch(setGetAllM24EmessiStartingDate(format(new Date(date), 'yyyy-MM-dd')))}
                                />
                            </div>
                            <div style={{ flex: '0.33' }}>
                                <Calendar
                                    label="Al"
                                    // onClear={(date) => dispatch(setGetAllEPFilterTo(date))}
                                    selected={m24EmessiState.GetAllM24EmessiFilters.to}
                                    onChange={(date) => dispatch(setGetAllFaseAvvioEndingDate(format(new Date(date), 'yyyy-MM-dd')))}
                                />
                            </div>
                           
                            <div style={{ flex: '0.33', display: 'flex', alignItems: 'center' }}>
                                <span>
                                    <Button
                                        size={"lg"}
                                        iconPosition={"off"}
                                        variant={"outline"}
                                        label="Cerca"
                                        color={"blue"}
                                        onClick={
                                            () => {
                                                dispatch(GetAllM24Emessi(m24EmessiState.GetAllM24EmessiFilters))
                                            }
                                        }
                                    />
                                </span>
                            </div>
                        </div>
                        {/* <div style={{ display: 'flex', justifyContent: 'right', flex: 0.3 }}>
                            <Pagination
                                numbResults={m24OpenState.GetAllFaseAvvioResponse ? m24OpenState.GetAllFaseAvvioResponse.total : 0}
                                pages={m24OpenState.GetAllFaseAvvioResponse?.totalPage || 1}
                                currentPage={m24OpenState.GetAllM24EmessiFilters.page ? m24OpenState.GetAllM24EmessiFilters.page : 0}
                                detailsResults={'clienti'}
                                setPage={
                                    (page) => {
                                        dispatch(setGetAllM24EmessiFiltersPage(page))
                                        dispatch(GetAllFaseAvvio(m24OpenState.GetAllM24EmessiFilters))
                                    }
                                }
                            />
                        </div> */}
                    </div>
                </div>
                <MonitoringM24EmessiList />
            </div>
        </Layout>
    )
}